// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__I5XNs","content":"ManualTimeModal_content__2Xo7P"};